import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import PlayerLock from './index';
import Action from 'actions';

class PlayerLocksList extends Component {
    onClick(isActive) {
        const {playerId} = this.props;
        this.props.dispatch(
            Action.set('SettingPopupState', {
                playerId,
                isActive,
                settingName: 'lock',
            }),
        );
    }

    render() {
        const {playerId, modesConfig, playersLock, playerSettingPopup} = this.props;

        const modes = modesConfig.all({asArr: true});

        if (isEmpty(modes)) {
            return null;
        }

        const isActive = playerSettingPopup.isActive(playerId, 'lock');
        const isLockedAnywhere = playersLock.isLockedAnywhere(playerId);

        return (
            <div className={`lock-holder${isActive ? ' active' : ''}`}>
                <button
                    className={`lock-btn${isLockedAnywhere ? ' active' : ''}`}
                    onClick={() => this.onClick(!isActive)}
                    title={isLockedAnywhere ? 'Lock enabled' : 'Lock disabled'}
                >
                    {isLockedAnywhere ? 'Lock enabled' : 'Lock disabled'}
                </button>
                <ul className="lock-drop">
                    {modes.map((mode) => {
                        return (
                            <li key={mode.getRole() + playerId} onClick={() => this.onClick(!isActive)}>
                                <PlayerLock className={`lock-btn`} playerId={playerId} mode={mode.getRole()} />
                                <span>{mode.getLabel()}</span>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {modesConfig, playersLock, playerSettingPopup} = state;
    return {
        modesConfig,
        playersLock,
        playerSettingPopup,
    };
}

export default connect(mapStatesToProps)(PlayerLocksList);
